module.exports = __webpack_public_path__ + "img/uploadshapes.3bcc7311.jpg";